export const TransactionStatus = {
    COMPLETE:"تکمیل شده",
    CANCEL:"لغو شده",
    REQUEST:"ثبت درخواست",
}
